export function useToast() {
  const toast = (
    message: string,
    type: 'success' | 'error' | 'info' = 'info'
  ) => {
    const timestamp = new Date().toLocaleTimeString()
    console.log(`[${timestamp}] [${type.toUpperCase()}] ${message}`)

    // Show browser alert for better visibility during development
    if (type === 'error') {
      // For errors, use alert to ensure user sees it
      alert(`❌ Error: ${message}`)
    } else if (type === 'success') {
      console.log(`✅ Success: ${message}`)
    }

    // You can enhance this later with a proper toast library like react-toastify
    // For now, we'll just log to console and show alerts for errors
  }

  return { toast }
}
